import { NgModule } from '@angular/core';
import { A11yModule } from '@angular/cdk/a11y';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedUiModule } from '@emi/shared/ui';
import { FilterTabsComponent } from './filter-tabs/filter-tabs.component';
import { FilterCountriesComponent } from './filter-countries/filter-countries.component';
import { KeywordFilterBarComponent } from './keyword-filter-bar/keyword-filter-bar.component';
import { CheckboxTreeComponent } from './checkbox-tree/checkbox-tree.component';
import { FilterSelectionsComponent } from './filter-selections/filter-selections.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatButtonModule } from '@angular/material/button';
import { PageBreakComponent } from './page-break/page-break.component';
import { FilterPromotionsComponent } from './filter-promotions/filter-promotions.component';
import { FilterTabConfigurationComponent } from './filter-tab-configuration/filter-tab-configuration.component';
import { FilterCategoriesComponent } from './filter-categories/filter-categories.component';
import { FilterAttributeTypesComponent } from './filter-attribute-types/filter-attribute-types.component';
import { FilterAttributesComponent } from './filter-attributes/filter-attributes.component';
import { FilterSuppliersComponent } from './filter-suppliers/filter-suppliers.component';
import { FilterRetailersComponent } from './filter-retailers/filter-retailers.component';
import { FilterRetailerTypesComponent } from './filter-retailer-types/filter-retailer-types.component';
import { FilterBrandsComponent } from './filter-brands/filter-brands.component';
import { MatDialogModule } from '@angular/material/dialog';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { ScrollDispatcher, ScrollingModule } from '@angular/cdk/scrolling';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatRadioModule } from '@angular/material/radio';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSelectModule } from '@angular/material/select';

@NgModule({
    imports: [
        A11yModule,
        CommonModule,
        FormsModule,
        MatExpansionModule,
        MatButtonModule,
        SharedUiModule,
        MatDialogModule,
        InfiniteScrollModule,
        ScrollingModule,
        MatDatepickerModule,
        MatFormFieldModule,
        ReactiveFormsModule,
        MatRadioModule,
        MatCheckboxModule,
        MatSelectModule
    ],
    providers: [ScrollDispatcher],
    declarations: [
        FilterTabsComponent,
        FilterCountriesComponent,
        CheckboxTreeComponent,
        FilterSelectionsComponent,
        KeywordFilterBarComponent,
        PageBreakComponent,
        FilterPromotionsComponent,
        FilterTabConfigurationComponent,
        FilterAttributeTypesComponent,
        FilterAttributesComponent,
        FilterCategoriesComponent,
        FilterSuppliersComponent,
        FilterBrandsComponent,
        FilterRetailersComponent,
        FilterRetailerTypesComponent,
    ],
    exports: [
        FilterTabsComponent,
        FilterCountriesComponent,
        CheckboxTreeComponent,
        FilterSelectionsComponent,
        KeywordFilterBarComponent,
        PageBreakComponent,
        FilterPromotionsComponent,
        FilterTabConfigurationComponent,
        FilterAttributeTypesComponent,
        FilterAttributesComponent,
        FilterSuppliersComponent,
        FilterBrandsComponent,
        FilterRetailersComponent,
        FilterRetailerTypesComponent,
    ],
})
export class FiltersModule {}
